export default "__VITE_ASSET__DlVc2hqb__"